<template>
  <div class="main">
    <el-form style="margin-top:10px"
      ref="form"
      :model="formData"
      label-width="80px"
      @submit.native.prevent
      class="main-form"
      :show-message="false"
      >
    <!-- <div class="add-box">
      <uploader :text="'将视频文件拖拽到此处，或'" :tips="'支持后缀为.mov或.mp4或.avi的视频文件，且不超过1G'" />
    </div> -->
    <el-form-item label="视频来源" required>
      <el-radio-group v-model="sourceType" @change="handleSourceTypeChange">
        <el-radio label="local">本地上传</el-radio>
        <el-radio label="link">外链引用</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="视频资源" v-if="sourceType === 'local'" required>
      <Uploadfile ref="Uploadfile" :uploadInfo="uploadInfo" @uploadres="uploadres" />
    </el-form-item>
    <el-form-item label="视频链接" v-if="sourceType === 'link'" prop="externalUrl"
        :rules="{ required: true, message: '请输入视频链接', trigger: 'blur' }">
        <el-input
            placeholder="请输入星火题库视频URL"
            v-model="formData.externalUrl"
            style="width: 50%">
        </el-input>
    </el-form-item>
    <el-form-item label="视频标题" prop="title"
        :rules="{ required: true, message: '视频标题', trigger: 'blur' }">
        <el-input
            placeholder="请输入"
            v-model="formData.title"
            maxlength="100"
            style="width: 50%"
            show-word-limit>
        </el-input>
    </el-form-item>
    <el-col :span="24">
    <el-form-item label="视频类型" prop="type"
        :rules="{ required: true, message: '视频类型', trigger: 'blur' }">
        <el-select v-model="formData.type" placeholder="请选择" ref="selectMode" style="width: 50%">
            <el-option
            v-for="item in vedioType"
            :key="item.id"
            :label="item.name"
            :value="item.id">
            </el-option>
          </el-select>
    </el-form-item>
    </el-col>
    <el-col :span="24">
    <el-form-item label="课程目录" prop="directoryId"
        :rules="{ required: false, message: '视频类型', trigger: 'blur' }">
        <el-cascader ref="cascader" style="width: 50%" :popper-append-to-body="false" popper-class="custom-dropdown"
          v-model="formData.directoryId"
          :show-all-levels="false" clearable filterable
          :props="props" :options="directoryList"
          @change="handleChange"
        ></el-cascader>
    </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item label="关键字" required prop="keys" :show-message="!formData.keys">
        <label-input @on-change="changeKey" :parentarr="getKey" ref="labelInput" />
      </el-form-item>
    </el-col>
    <el-col :span="24">
      <el-form-item label="适合专业">
        <el-checkbox-group v-model="formData.profession" @change="updateProfessionName">
          <el-checkbox :label="val.id" v-for="val in professionData" :key="val.id">{{val.dictionaryName}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-col>
    </el-form>
    <div class="btns">
      <el-button type="primary" plain @click="close(true)">取消</el-button>
      <div style="display:inline-block">
        <el-button
          type="primary"
          style="width:120px;margin-left: 10px"
          @click="submit(false)"
        >保存</el-button>
        <el-button v-if="!$route.query.id"
          type="primary"
          style="width:120px;"
          @click="submit('next')"
        >保存并下一题</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { vedioType } from '@/data/data';
import Uploadfile from '@/components/Uploadfile';
import { vedioServer, courseServer, keyServer } from '@/api/api'
export default {
  components: {Uploadfile},
  computed: {
    getKey () {
      return this.formData.keys ? this.formData.keys.split(';') : []
    }
  },
  data () {
    return {
      props: {
        multiple: false,
        label: 'name',
        value: 'id',
        children: 'subList',
        checkStrictly: true,
        emitPath: false
      },
      uploadInfo: {
        tip: '支持后缀为.mov或.mp4的视频文件，且不超过1G',
        accept: '.mov,.mp4',
        multiple: false,
        fileList: [],
        fileSize: 1000
      },
      directoryList: [],
      uploadData: {},
      sourceType: 'local', // local:本地上传 link:外链引用
      vedioType,
      professionData: [],
      formData: {
        title: '',
        type: '',
        directoryId: null,
        keys: '',
        filePath: null,
        originalFile: null,
        externalUrl: '',
        profession: [],
        professionName: ''
      }
    }
  },
  methods: {
    uploadres (res) {
      this.formData.filePath = res.response ? res.response.data.fileKey : null
      this.formData.originalFile = res.file ? res.file.name : null
    },
    getDetail () {
      vedioServer.vedioDetail({
        id: this.$route.query.id
      }).then(res => {
        const {code, data, message} = res
        if (code === '0') {
          this.formData = {
            title: data.title,
            type: data.type,
            directoryId: data.directoryId,
            keys: data.keys,
            filePath: data.filePath,
            originalFile: data.originalFile,
            externalUrl: data.externalUrl || '',
            profession: data.profession ? data.profession.split(',') : [],
            professionName: data.professionName
          }
          this.updateProfessionName()
          if (data.source === 1 || data.externalUrl) {
            this.sourceType = 'link'
          } else {
            this.getfileurl([data.filePath])
            this.uploadInfo.fileList.push({key: data.filePath, name: data.originalFile})
          }
        } else {
          this.$message.error(message)
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    async submit (isnext) {
      let flag = await this.submitForm('form');
      if (!flag) {
        this.$message.error('请检查必填!')
        return
      }
      if (this.sourceType === 'local' && !this.formData.filePath) {
        this.$message.error('请上传文件!')
        return
      }
      if (this.sourceType === 'link') {
        if (!this.formData.externalUrl) {
          this.$message.error('请输入视频链接!')
          return
        }
        if (!/^https?:\/\/\S+\.\S+/.test(this.formData.externalUrl.trim())) {
          this.$message.error('请输入正确的视频链接地址!')
          return
        }
      }
      let obj = {
        profession: this.formData.profession.join(','),
        professionName: this.formData.professionName,
        source: this.sourceType === 'link' ? 1 : 0, // 视频来源 0-本系统上传 1-外部链接
        filePath: this.sourceType === 'local' ? this.formData.filePath : null,
        originalFile: this.sourceType === 'local' ? this.formData.originalFile : null,
        externalUrl: this.sourceType === 'link' ? this.formData.externalUrl.trim() : null
      }
      if (this.$route.query.id) {
        vedioServer.vedioUpdate({
          id: this.$route.query.id,
          ...this.formData,
          ...obj
        }).then(res => {
          const {code, data, message} = res
          if (code === '0') {
            this.$message.success(message)
            this.close(false)
          } else {
            this.$message.error(message)
          }
        }).catch(error => {
          this.$message.error(error.response.data.message)
        })
        return
      }
      vedioServer.vedioAdd({
        ...this.formData,
        ...obj
      }).then(res => {
        const {code, data, message} = res
        if (code === '0') {
          this.$message.success(message)
          if (isnext) {
            this.clearForm()
          } else {
            this.close(false)
          }
        } else {
          this.$message.error(message)
        }
      }).catch(error => {
        this.$message.error(error.response.data.message)
      })
    },
    getfileurl (fileKeys) {
      this.$getUrl({
      fileKeys: fileKeys.join()
      }).then(obj => {
        if (obj) {
          this.uploadInfo.fileList.forEach((e) => {
            if (e) {
              this.$set(e, 'url', obj[e.key] || '')
            }
          })
        }
      })
    },
    clearForm () {
      this.formData = {
        title: '',
        type: '',
        directoryId: null,
        keys: '',
        filePath: null,
        originalFile: null,
        externalUrl: '',
        profession: this.formData.profession,
        professionName: this.formData.professionName
      }
      // 保存并下一题：保留当前选择的视频来源，仅清空内容
      if (this.sourceType === 'link') {
        this.uploadInfo.fileList = []
        this.$refs.Uploadfile.clearFormList()
      }
    },
    // 切换引用方式：本地上传/外链引用二选一，切换时清空另一种方式的内容
    handleSourceTypeChange (val) {
      if (val === 'link') {
        this.formData.filePath = null
        this.formData.originalFile = null
        this.uploadInfo.fileList = []
        this.$refs.Uploadfile.clearFormList()
        this.$refs.form.clearValidate('externalUrl')
      } else {
        this.formData.externalUrl = ''
        this.$refs.form.clearValidate('externalUrl')
      }
    },
    submitForm (prop) {
      return new Promise((resolve) => {
        this.$refs[prop].validate((valid) => {
          if (valid) {
            resolve(true)
          } else {
            resolve(false)
          }
        });
      })
    },
    changeKey (v) {
      this.$set(this.formData, 'keys', v.join(';'));
    },
    handleChange(value) {
      // 手动收起下拉框
      this.$nextTick(() => {
        this.$refs.cascader.dropDownVisible = false; // 收起下拉框
      })
    },
    // 课程目录
    selectData () {
      courseServer.profressionDirectory().then(res => {
        const {code, data, message} = res
        if (code === '0') {
          this.INITData(data)
          this.directoryList = data
        } else {
          this.$message.error(message)
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    // 专业数据
    selectDataV1 () {
      keyServer.profession({
        dictionaryKey: 'profession'
      }).then(res => {
        const {code, data, message} = res
        if (code === '0') {
          this.professionData = data
          if (!this.$route.query.id) {
            this.formData.profession = this.professionData.map(v => v.id)
            this.updateProfessionName()
          }
        } else {
          this.$message.error(message)
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    // 更新 professionName 方法
    updateProfessionName() {
      const selectedIds = this.formData.profession;
      const names = this.professionData
        .filter(item => selectedIds.includes(item.id))
        .map(item => item.dictionaryName);
      this.formData.professionName = names.join(',');
    },
    INITData(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].subList.length < 1) {
          data[i].subList = undefined // subList若为空数组，则将subList设为undefined
        } else {
          this.INITData(data[i].subList) // subList若不为空数组，则继续 递归调用 本方法
        }
      }
    },
    async close (flag) {
      if (flag) {
        this.$confirm('当前页未保存，是否确认继续', '提示', { type: 'warning' }).then(() => {
          window.close()
        })
      } else {
        window.close()
      }
    }
  },
  created () {
    this.selectData()
    this.selectDataV1()
    if (this.$route.query.id) {
      this.getDetail()
    }
  }
}
</script>

<style scoped lang='scss'>
.main{
  text-align: left;
  margin: 0px 10px;
}
.main-form {
  overflow: hidden;
  margin: 15px 0;
  padding: 15px 20px 0;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 1px 4px 0px rgba(30, 155, 255, 0.3);
}
.add-box {
  margin-bottom: 10px;
}
.btns{
  text-align: center;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0px;
  line-height: 80px;
  background: #f9fbff;
  width: 100%;
  z-index: 100;
}
</style>


// WEBPACK FOOTER //
// src/views/resource/page/addvedioIndex.vue